/**
 * Shared billing-style chrome — discover grids now use feedSurface (see feedSurface.js).
 */

import { discoverGridShellClass, feedSurfaceClass } from "./feedSurface";

export const billingDotGridClass =
  "pointer-events-none absolute inset-0 overflow-hidden rounded-radius-md opacity-[0.5] dark:opacity-[0.32] bg-[radial-gradient(circle_at_1px_1px,_rgb(148_163_184/0.2)_1px,_transparent_0)] [background-size:16px_16px]";

export function billingShellBorderShadow(isDark) {
  return "border-separator-default shadow-sm";
}

/** @deprecated Use discoverGridShellClass — kept for legacy imports. */
export function billingCampaignGridShellClass(isDark) {
  return `relative rounded-radius-md border ${discoverGridShellClass(isDark)}`;
}

/** Mint space Creator Rewards list — gradient border + pulsing mint glow when selected. */
export function billingCampaignCardClass(isDark, isSelected) {
  const tone = isDark ? "dark" : "light";
  const base = `billing-campaign-card h-full w-full cursor-pointer billing-campaign-card--${tone}`;
  if (isSelected) {
    return `${base} billing-campaign-card--${tone}-selected animate-billing-campaign-highlight relative z-10`;
  }
  return base;
}

/** Mint space window top bar (Discover / Analytics / …). */
export function billingMintTopNavClass(isDark) {
  return "relative border-b border-separator-default bg-transparent";
}

/** Pill buttons in mint top nav. */
export function billingMintNavPillClass(isDark, isActive) {
  const size = "rounded-radius-xs px-2.5 py-1 text-caption-1-semibold";
  if (isActive) {
    return isDark
      ? `${size} border border-accent-default bg-accent-tinted text-accent-text shadow-sm`
      : `${size} border border-accent-default bg-accent-tinted text-status-success shadow-sm`;
  }
  return isDark
    ? `${size} border border-transparent bg-transparent text-slate-300 hover:border-white/10 hover:bg-white/[0.04]`
    : `${size} border border-transparent bg-transparent text-slate-600 hover:border-slate-200 hover:bg-slate-50`;
}
